<template>
  <div>
    <div v-if="loaded">

      <div v-if="coordinates" class="inout-table">
        <div class="left-bar">
          <div class="item">{{ 'base.animal_type' | translate }}</div>
          <div class="item">{{ 'base.ration' | translate }}</div>
          <div class="item">{{ 'base.feed_days' | translate }}</div>

          <div v-for="(item, index) in coordinates.ingredient_list"
            :key="index" :title="item" class="item">
              {{ item }}<br>{{ 'base.plan_fact' | translate }}
          </div>

          <div class="item">{{ 'base.weight' | translate }} [{{ 'base.kg' | translate }}]<br>
            {{ 'base.plan_fact' | translate }}</div>
          <div class="item">{{ 'base.deviation' | translate }} [%]</div>
          <div class="item">{{ 'base.inout' | translate }} [{{ 'base.currency' | translate }} / {{ 'base.kg' | translate }}]</div>
          <div class="item">{{ 'base.inout' | translate }} [{{ 'base.currency' | translate }}]<br>{{ 'base.fact' | translate }}</div>
        </div>

        <div class="content-wrapper">
          <vue-scroll>
            <div class="content">
                <div v-for="(item, key) in columns"
                  :key="key" class="block">

                    <div class="item" :title="item.animal_type_label">
                      {{ item.animal_type_short }}</div>

                    <div class="item" :title="item.ration_label">
                      {{ item.ration_short }}</div>

                    <div class="item">{{ item.korm_days }}</div>

                    <div v-for="(item, index) in item.ingredients"
                      :key="index" class="item">{{ item.label }}</div>

                    <div class="item h2">{{ item.plan_weight | floor }} / {{ item.fact_weight | floor }}</div>

                    <div class="item">{{ item.percent + '%' }}</div>

                    <div class="item">{{ item.price_label }}</div>

                    <div class="item h2">{{ item.fact_price }}</div>
                </div>

                <div class="block green">
                  <div class="item">{{ 'base.total' | translate }}</div>
                  <div class="item"></div>
                  <div class="item">{{ total.korm_days }}</div>
                  <div v-for="(value, index) in total.ingredients"
                    :key="index" class="item">{{ value | floor }}</div>
                  <div class="item">{{ total.plan_weight | floor }} / {{ total.fact_weight | floor }}</div>
                  <div class="item">{{ total.percent + '%' }}</div>
                  <div class="item">{{ total.price_label }}</div>
                  <div class="item">{{ total.fact_price }}</div>
                </div>
            </div>
          </vue-scroll>
        </div>
      </div>

      <!-- If table is empty -->
      <div v-else class="table__empty">
        {{ (allowView ? 'base.table_is_empty' : 'perm.info.no_view') | translate }}
      </div>
    </div>

    <v-preloader v-else/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import filterMixin from '@/mixins/filter.mixin'

export default {
  name: 'Inout',

  mixins: [filterMixin],

  mounted () {
    this.loadData()
  },

  data: () => ({
    coordinates: {},
    columns: [],
    total: {
      korm_days: 0,
      fact_price: 0,
      price_label: 0,
      percent: 0,
      ingredients: {},
      plan_weight: 0,
      fact_weight: 0
    },
    loaded: false
  }),

  methods: {
    ...mapActions('reports', [
      'getInout'
    ]),

    async loadData () {
      // TODO: refactor
      if (this.allowView) {
        this.loaded = false
        this.columns = []
        if (this.filters) {
          await this.getInout(this.filters)
          const { coordinates, animal_type: animalType } = this.inout
          this.coordinates = coordinates
          for (let key in animalType) {
            let item = animalType[key]
            this.total.korm_days += item.animal_count
            let column = {
              animal_type_label: this.coordinates.animal_type_list[key],
              animal_type_short: this.shortVersion(this.coordinates.animal_type_list[key]),
              ration_label: this.getArrLabel(item.rations),
              korm_days: item.animal_count,
              ingredients: [],
              fact_price: 0,
              fact_weight: 0,
              plan_weight: 0
            }
            column.ration_short = this.shortVersion(column.ration_label)
            for (let ingKey in item.ingredients) {
              let ingred = item.ingredients[ingKey]
              this.total.ingredients[ingKey] = this.total.ingredients[ingKey] !== undefined ? this.total.ingredients[ingKey] + ingred.plan_weight : ingred.plan_weight
              column.fact_price += ingred.fact_price ? ingred.fact_price : 0
              column.fact_weight += ingred.fact_weight ? ingred.fact_weight : 0
              column.plan_weight += ingred.plan_weight ? ingred.plan_weight : 0
              let detail = {
                plan: ingred.plan_weight,
                fact: ingred.fact_weight,
                label: Math.floor(ingred.plan_weight) + ' / ' + Math.floor(ingred.fact_weight)
              }
              column.ingredients.push(detail)
            }
            column.percent = Math.round((column.fact_weight - column.plan_weight) / column.plan_weight * 100)
            column.price_label = column.fact_price ? Math.round(column.fact_price / column.fact_weight) : 0
            this.total.price_label += column.price_label
            this.total.fact_price += column.fact_price
            this.total.percent += column.percent
            this.total.plan_weight += column.plan_weight
            this.total.fact_weight += column.fact_weight
            this.columns.push(column)
          }
          this.total.percent = this.total.percent / this.columns.length
        }
      }
      this.loaded = true
    },

    shortVersion (str) {
      return str.length > 12 ? (str.substring(0, 12) + '...') : str
    },

    getArrLabel (arr) {
      let content = ''
      for (let index in arr) {
        content += arr[index] + ', '
      }
      return content.substring(0, content.length - 2)
    }
  },

  computed: {
    ...mapGetters('reports', [
      'inout',
      'filters'
    ]),

    allowView () {
      return this.hasPermission('inout', 'view')
    }
  }
}
</script>

<style scoped>
  .inout-table {
    display: flex;
  }

  .left-bar {
    padding: 5px 20px;
    background: #fff;
    display: flex;
    flex-direction: column;
    margin-right: 10px;
    width: 150px;
  }

  .left-bar .item {
    height: 54px;
    font-size: 13px;
    color: #979797;
    font-weight: 300;
    padding: 12px 0;
  }

  .inout-table .content-wrapper {
    width: 1015px;
  }

  .inout-table .content {
    display: flex;
  }

  .inout-table .content .block {
    width: 150px;
    padding: 5px 20px;
    background: #fff;
    border-radius: 10px;
    font-size: 14px;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 10px;
  }

  .inout-table .block .item {
    height: 54px;
    padding: 12px 0;
    font-size: 13px;
    
  }

  .inout-table .block .item.h2 {
    height: 54px;
  }

  .block.green {
    background: #1DA643 !important;
  }

  .block.green .item {
    color: #fff;
  }

  .table__empty {
    width: 100%;
  }
</style>
